import { render, staticRenderFns } from "./VvScale.vue?vue&type=template&id=7aa36996&scoped=true&"
import script from "./VvScale.vue?vue&type=script&lang=js&"
export * from "./VvScale.vue?vue&type=script&lang=js&"
import style0 from "./VvScale.vue?vue&type=style&index=0&id=7aa36996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa36996",
  null
  
)

export default component.exports